<template>
  <div class="CardNPconment">
    <van-cell-group>
      <!-- <van-cell title="地区" is-link :value="district" @click="onDistrict"/> -->
	  <van-cell title="热力公司" is-link :value="district" @click="onCompany"/>
      <van-cell title="小区" is-link :value="villageData.villageName" @click="onVillage"/>
    </van-cell-group>
    <van-cell-group class="cardIcon">
      <van-field
        v-model="userCardNumber"
        required
        clearable
        label="热力卡号"
        placeholder="请输入热力卡号"
        @blur = "Cardtest"
      />
    </van-cell-group>
    <van-col span="24" type="flex" justify="space-between" class="barBtn">
      <van-button round type="danger" size="large" class="saveBth" :disabled="isSave" @click.prevent="UpdateInfo">去查询</van-button>
    </van-col>
    <van-popup
      v-model="isShow"
      position="bottom"
    >
		<van-picker
		  show-toolbar
		  :columns="columns"
		  @confirm="onCompanyConfirm"
		  @cancel="isShow = false"
		  v-show = 'isCompany'
		  value-key="companyName"
		/>
      <!-- <van-picker
        show-toolbar
        :columns="columns"
        @confirm="onCityConfirm"
        @cancel="isShow = false"
        v-show = 'isCity'
        value-key="regionName"
      />
      <van-picker
        show-toolbar
        :columns="columns"
        @confirm="onDistrictConfirm"
        @cancel="isShow = false"
        v-show = 'isDistrict'
        value-key="regionName"
      /> -->
    </van-popup>
    <div class="popCon" v-show="isVillage" v-if="villageList">
      <div class="returnBtn"><van-button icon="arrow-left" type="primary" @click="isVillage=false">返回</van-button></div>
      <van-index-bar :index-list="indexList" sticky >
        <div v-for="index in indexList" :key="index">
          <van-index-anchor :index="index"/>
          <div v-for="item in villageList">
            <van-cell :title="item.villageName" v-if="item.villageNameS == index" @click="VillageSelect(item.villageId,item.villageName)"/>
          </div>
        </div>
      </van-index-bar>
    </div>
  </div>
</template>

<script>
  import { Toast } from 'vant';import store from '../../store';
  import { reqCompany, reqVillage, reqRoominfoList} from '../../api'
  import vPinyin from '../../common/js/vue-py.js';
  import commonJS from '../../common/js/commonJS.js';
	export default {
    name:"cardnumpayment",
    i18n: {
      'zh-CN': {
        text: '文本',
        customIndexList: '自定义索引列表'
      },
      'en-US': {
        text: 'Text',
        customIndexList: 'Custom Index List'
      }
    },
    data() {
      return {
        isSave:true,
        isShow: false,
        userCardNumber:'',
        city:'请选择您所在的城市',
        isCity:false,
        district:'请选择所属热力公司',
        isDistrict:false,
        villageData:{
          villageId:'',
          villageName:'请选择您所在的小区',
        },
        villageList:[],
        isVillage:false,
        columns:[],
        AreaCity:{
          trendName:'',
          trendId:''
        },
        AreaDistrict:{
          trendName:'',
          trendId:''
        },
        indexList:[],
		companyData:{},
		isCompany:false
		
      }
    },
    mounted(){

    },
	  methods:{
      /*
      * 获取城区
      * */
     //  reqAreaData(AreaData){
     //    if(!AreaData){
     //      AreaData = {}
     //    }
     //    reqArea(AreaData).then(res => {
     //      if(res.success){
     //        this.columns = res.data
     //      }else {
     //        Toast.fail({message:'系统错误，请联系管理员！',className:'apiLoading'});
     //      }
     //    })
     //  },
     //  /*
     //  * 点击选取城市
     //  * */
     //  onCity(){
     //    this.AreaDistrict.trendName =''
     //    this.AreaDistrict.trendId =''
     //    this.district = '请选择您所在的地区'
     //    this.villageData.villageId = '';
     //    this.villageData.villageName = '请选择您所在的小区';
     //    this.isShow = true
     //    this.isCity = true
     //    this.isDistrict = false
     //    this.reqAreaData();
     //  },
     //  /*
     //  * 点击选取区
     //  * */
     //  onDistrict(){
     //    if(!this.AreaCity.trendId||!this.AreaCity.trendName){
     //      Toast.fail({message:'请先选择城市！',className:'apiLoading'});
     //      return false
     //    }
     //    this.villageData.villageId = '';
     //    this.villageData.villageName = '请选择您所在的小区';
     //    this.isShow = true
     //    this.isCity = false
     //    this.isDistrict = true
     //  },
     //  /*
     //  * 点击城市选取弹窗确定
     //  * */
     //  onCityConfirm(value, index){
     //    this.AreaCity.trendName = value.regionName
     //    this.AreaCity.trendId = value.regionId;
     //    this.isShow = false
     //    this.city = value.regionName
     //    this.reqAreaData(this.AreaCity);
     //  },
     //  /*
     // * 点击区选取弹窗确定
     // * */
     //  onDistrictConfirm(value, index){
     //    this.AreaDistrict.trendName = value.regionName
     //    this.AreaDistrict.trendId = value.regionId;
     //    this.isShow = false
     //    this.district = value.regionName
     //  },
	  /*
	  *  点击获取热力公司列表
	  * */	  
	  onCompany(){
		  this.district = '请选择所属热力公司'
		  this.isShow = true
		  this.isDistrict = false
		  this.isCompany =true
		  this.reqCompanyData();
	  },
	   /*
	   * 点击城市选取弹窗确定
	   * */
	   onCompanyConfirm(value, index){
		   console.log(value);
	     this.companyData.companyName = value.companyName
	     this.companyData.companyId = value.companyId;
	     this.isShow = false
		 this.isCompany =false
		 this.district = value.companyName
	     //this.reqAreaData(this.AreaCity);
	   },
	  //获取热力公司
	  reqCompanyData(){
		  reqCompany().then(res => {
			if(res.success){
				this.columns = res.data
			}
		  })
	  },
      /*
      *  点击获取小区列表
      * */
      onVillage(){
        let _that = this
        _that.isVillage = false
        if(this.companyData.companyId){
          let data = {
            //trendId:this.AreaDistrict.trendId,
            companyId:this.companyData.companyId // TODO 微信进来取companyId
          }
          //获取对应小区
          reqVillage(data).then(res => {
            if(res.success){
              _that.villageList = res.data;
              for(let k in _that.villageList){
                let villageNameS = '',villageNameP='';
				        //把小区转换成拼音取首字母排序去重
                  villageNameP = vPinyin.chineseToPinYin(_that.villageList[k].villageName);
                  villageNameS= villageNameP.substr(0,1);
                  _that.indexList.push(villageNameS);
                  _that.indexList = commonJS.unique5(_that.indexList)
                  _that.indexList = commonJS.letterSort(_that.indexList)
                  _that.villageList[k].villageNameS = villageNameS
              }
              if(_that.villageList.length == 0){
                Toast.fail({message:'暂无开通缴费的小区！',className:'apiLoading'});
              }else if(_that.villageList.length > 0){
                _that.isVillage = true
              }
            }else {
              Toast.fail({message:'系统错误，请联系管理员！',className:'apiLoading'});
            }
          })
        }else{
          Toast.fail({message:'请先选择所属热力公司！',className:'apiLoading'});
        }
      },
      /*
      *  点击选择小区
      * */
      VillageSelect(villageId,villageName){
        this.villageData.villageId = villageId;
        this.villageData.villageName = villageName;
        this.isVillage = false
      },
      /*
      * 热力卡号input失去焦点验证必填
      * */
      Cardtest(){
        let testVerify = this.testVerify();
        if(!testVerify){
          this.isSave = true
        }else{
          this.isSave = false
        }
      },
      /*
     *  必填验证
     * */
      testVerify(){
        if(!this.companyData.companyId||!this.companyData.companyName){
          Toast.fail({message:'请选择所属热力公司！',className:'apiLoading'});
          return false
        }
        if(!this.villageData.villageName||!this.villageData.villageId){
          Toast.fail({message:'请选择所在小区！',className:'apiLoading'});
          return false
        }
        if(!this.userCardNumber){
          Toast.fail({message:'请填写热力卡号！',className:'apiLoading'});
          return false
        }
        return true
      },
      /*
      * 去查询
      * */
      UpdateInfo(){
        let testVerify = this.testVerify();
        if(testVerify){
          let data = {
            userCardNumber:this.userCardNumber,
            villageId:this.villageData.villageId
          }
          // 查询房屋信息
          reqRoominfoList(data).then(res => {
            if(res.success){
              if(res.data.length != 0){
                this.$router.push({
                  path:'/paydetail',
                  name:'paydetail',
                  query:{roomId:res.data[0].roomId}
                })
              }else{
                Toast.fail({message:'未查询到此热力卡号房屋信息！',className:'apiLoading'});
              }
            }else {
              Toast.fail({message:'系统错误，请联系管理员！',className:'apiLoading'});
            }
          })
        }else{
          this.isSave = true
          Toast.fail({message:'请填写热力卡号！',className:'apiLoading'});
        }
      },

    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus">
  @import "../../common/stylus/mixins.styl"
  .CardNPconment
    .van-cell-group
      margin-top 8px
      .van-cell
        height 98px!important
        line-height 98px
        font-size 30px
        color #222222
        padding-left 40px
        .van-cell__value
          font-size 28px
        .van-cell__left-icon, .van-cell__right-icon
          font-size 26px
          margin 0px 10px
          line-height 98px
        .van-field__control
          text-align right
          padding-right 40px
        .van-field__label
          width 120px
    .van-picker__toolbar
      height 85px
      .van-picker__confirm, .van-picker__cancel
        font-size 28px
        line-height 85px
    .van-picker-column
      font-size 32px
    .cardIcon
      padding-right 10px
      input
        padding-right 50px!important
        background url("./images/saosao.png") no-repeat center right
        background-size 32px auto
    .barBtn
      padding 20% 40px 0px
      .saveBth
        color #ffffff
        font-size 32px
        background #ff6d02
        height 88px
        margin-top 200px
        line-height 88px
    .van-popup
      box-sizing border-box
      padding 20px
      &--right
        width 100%
        height 100%
    .popCon
      width 100%
      height 100%
      background #ffffff
      position absolute
      top 0px
      left 0px
      .returnBtn
        background #ebedf0
        margin-bottom 10px
    .van-index-bar
      padding 0px 30px
      .van-index-bar__index
        font-size 24px
        line-height 40px
      .van-index-anchor
        font-size 30px
        background #ebedf0
        padding 8px 10px
      .van-cell
        font-size 28px
        padding 10px 20px
        line-height 45px
        border-bottom 1px solid #ccc
	.van-picker-column__item
		height 1rem
</style>



// WEBPACK FOOTER //
// src/pages/CardNumPayment/CardNumPayment.vue